import { useFormContext } from 'react-hook-form'

import { RIVERSIDE_SLUGS } from '@/constants/hor'
import type { AccommodationFormData } from '@/pages/accommodation/types'

import { useCompany } from './useCompany'

export const useIsRiverside = () => {
  const { watch } = useFormContext<AccommodationFormData>()
  const company = useCompany(watch)

  const isRiverside = RIVERSIDE_SLUGS.includes(company?.slug)

  return {
    isRiverside,
  }
}
